import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
const FooterLink = ({ name, link, blank }) => {
    return (_jsx("div", { className: "footer-link", children: blank ? (_jsx("a", { href: link, target: "_blank", "aria-label": name, children: name })) : (_jsx(Link, { to: link, "aria-label": name, children: name })) }));
};
export default FooterLink;
